import { Client, RouteGenerator } from "silver";

export class SetLanguageService {
	constructor(
		private client: Client,
		private router: RouteGenerator
	) { }

	public setLanguage(lang: string): void {
		const route = this.router.routeFromPathInfo(this.client.url);
		const url = this.router.generate(route.path, route.action, {
			...route.parameters,
			set_lang: lang
		}, route.extension);
		this.client.open(url);
	}
}
